<template>
  <transition name="fade" v-on:enter="enter">
    <div v-show="visible" class="v-tooltip" :style="calculate" v-if="text">
      <span ref="tip" :class="[position, size]" v-html="text"></span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      text: '',
      visible: true,
      position: 't-top',
      size: 't-md',
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      rkey: 0,
      tip: 0,
      avaliableRef: true,
      tipHeight: 0,
      tipWidth: 0,
      error: 0,
    };
  },
  updated() {
    try {
      this.tipHeight = this.$refs.tip.offsetHeight;
      this.tipWidth = this.$refs.tip.offsetWidth;
    } catch (error) {
      this.error = error;
    }
  },
  computed: {
    calculate() {
      const { tipHeight, tipWidth } = this;
      let base = {};

      if (this.position === 't-bottom') {
        base = {
          top: `${this.top + this.height + 2}px`,
          left: `${this.left + this.width / 2 + tipWidth / 2 - tipWidth}px`,
        };
      } else if (this.position === 't-top') {
        base = {
          top: `${this.top - 2 - tipHeight}px`,
          left: `${this.left + this.width / 2 + tipWidth / 2 - tipWidth}px`,
        };
      } else if (this.position === 't-left') {
        base = {
          top: `${this.top + this.height / 2 - tipHeight / 2}px`,
          left: `${this.left - tipWidth - 2}px`,
        };
      } else if (this.position === 't-right') {
        base = {
          top: `${this.top + this.height / 2 - tipHeight / 2}px`,
          left: `${this.left + this.width + 2}px`,
        };
      }
      return base;
    },
  },
  methods: {
    enter: function (el, done) {
      this.tipHeight = el.firstChild.offsetHeight;
      this.tipWidth = el.firstChild.offsetWidth;
      done();
    },
  },
};
</script>

<style lang="scss" scope>
$color_1: #fff;
$background_color_1: #294380;
$border_color_1: #294380 transparent transparent transparent;
$border_color_2: transparent transparent #294380 transparent;
$border_color_3: transparent #294380 transparent transparent;
$border_color_4: transparent transparent transparent #294380;

$color_2: #fff;
$background_color_2: #000;
$border_color_5: #000 transparent transparent transparent;
$border_color_6: transparent transparent #000 transparent;
$border_color_7: transparent #000 transparent transparent;
$border_color_8: transparent transparent transparent #000;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-tooltip {
  position: absolute;
  display: inline-block;
  > :first-child {
    color: $color_1;
    font-size: 12px;
    text-align: center;
    padding: 2px 4px;
    border-radius: 2px;
    z-index: 1001;
    position: absolute;
    width: max-content;
  }
  > .t-top {
    visibility: visible;
    max-width: 150px;
    background-color: $background_color_1;
    position: absolute;
  }
  > .t-bottom {
    visibility: visible;
    max-width: 150px;
    background-color: $background_color_1;
    position: absolute;
  }
  > .t-right {
    visibility: visible;
    max-width: 150px;
    background-color: $background_color_1;
    position: absolute;
  }
  > .t-left {
    visibility: visible;
    max-width: 150px;
    background-color: $background_color_1;
    position: absolute;
  }
  > .t-xs {
    max-width: 80px;
  }
  > .t-sm {
    max-width: 120px;
  }
  > .t-lg {
    max-width: 200px;
  }
  > .t-xl {
    max-width: 250px;
  }
}
</style>
